<template>
  <el-cascader
    v-model="selected"
    :options="areaList"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
		:filterable="filterable"
    :props="{ checkStrictly: checkStrictly }"
    :style="{ width: width || '' }"
    @change="change"
		:size="size"
  />
</template>

<script>
import areaJson from '@/assets/json/area.json'
export default {
  props: {
    checkStrictly: {
      type: Boolean,
      default: false
    },
    // 1-只获取省 2-省市 3-省市区
    type: {
      type: Number,
      default: 3
    },
    disabled: {
      type: Boolean,
      default: false
    },
		size: {
		  type: String,
		  default: ''
		},
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: true
    },
		filterable: {
			type: Boolean,
			default: true
		},
    width: {
      type: String,
      default: ''
    },
    value: {
      type: [Array, String],
      required: true
    }
  },
  data() {
    return {
      selected: this.value
    }
  },
  computed: {
    areaList() {
      const data = JSON.parse(JSON.stringify(areaJson))
      if (this.type === 1 || (this.value && this.value.length == 1)) {
        return data.map(item => {
          return {
            label: item.label,
            value: item.value
          }
        })
      } else if (this.type === 2 || (this.value && this.value.length == 2)) {
        return data.map(item => {
          item.children = item.children.map(itm => {
            return {
              label: itm.label,
              value: itm.value
            }
          })
          return item
        })
      } else {
        return data
      }
    }
  },
  watch: {
    value(val) {
      this.selected = val
    }
  },
  methods: {
    change(val) {
      this.$emit('input', val)
      const data = JSON.parse(JSON.stringify(areaJson))
      const ObjArr = this.getDepart(val, data)
      this.$emit('change', ObjArr)
    },
    // 回显中文名称
    getDepart(arr, data, ObjArr = []) {
      if (typeof data === 'object') {
        for (let i = 0; arr[i] !== undefined; i++) {
          for (let j = 0; data[j] !== undefined; j++) {
            if (Number(arr[i]) === Number(data[j].value)) {
              ObjArr.push({
                label: data[j].label,
                value: data[j].value
              })
            }
          }
        }
        for (let m = 0; data[m] !== undefined; m++) {
          this.getDepart(arr, data[m].children, ObjArr)
        }
      }
      return ObjArr
    }
  }
}
</script>

<style>

</style>
